import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'
import {
  IWindowPickPrismaSchemaRPC,
  IProjectOpenRPC,
} from '@prisma/studio-types'

import ThemeStore from 'stores/theme/ThemeStore'
import UpdateStore from 'stores/update/UpdateStore'

import Button from 'components/button/Button'
import ProjectList from './ProjectList'

import LogoType from 'assets/icons/logotype.svg'
import Download from 'assets/icons/download.svg'

import styles from './splash.scss'

@observer
export default class Splash extends React.Component<{}> {
  async componentDidMount() {
    await UpdateStore.check()
  }

  handleOpen = async () => {
    const {
      error,
      data,
    } = await window.transport.request<IWindowPickPrismaSchemaRPC>({
      channel: 'window',
      action: 'pickPrismaSchema',
      payload: {
        data: null,
      },
    })

    if (error) {
      return
    }

    await window.transport.request<IProjectOpenRPC>({
      channel: 'project',
      action: 'open',
      payload: {
        data: {
          schemaPath: data.path,
        },
      },
    })
  }

  handleInstallUpdate = async () => {
    await UpdateStore.download()
    await UpdateStore.install()
  }

  handleCancelDownload = async () => {
    await UpdateStore.cancelDownload()
  }

  render() {
    return (
      <div
        className={cn(styles.container, {
          'theme--light': ThemeStore.theme === 'light',
          'theme--dark': ThemeStore.theme === 'dark',
        })}
      >
        <div className={styles.container}>
          <div className={styles.left}>
            <div className={styles.logotype}>
              <img src="images/icon-1024.png" className={styles.logo} />
              <LogoType className={styles.type} />
            </div>
            {UpdateStore.hasCheckedForUpdates && !UpdateStore.isUpToDate && (
              <div className={styles.updateContainer}>
                <Download className={styles.downloadIcon} />
                {!UpdateStore.isDownloading && !UpdateStore.isInstalling && (
                  <>
                    <span className={styles.updateText}>
                      New version available
                    </span>
                    <Button green onClick={this.handleInstallUpdate}>
                      Update
                    </Button>
                  </>
                )}

                {UpdateStore.isDownloading && (
                  <>
                    <span className={styles.updateText}>Downloading ..</span>
                    <Button red onClick={this.handleCancelDownload}>
                      Cancel
                    </Button>
                  </>
                )}

                {UpdateStore.isInstalling && (
                  <>
                    <span className={styles.updateText}>Installing ..</span>
                    <Button red onClick={this.handleCancelDownload}>
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            )}

            <div className={styles.links}>
              <a className={styles.link}>{STUDIO_VERSION}</a>|
              <a
                className={styles.link}
                href="https://github.com/prisma/studio/releases"
                target="_blank"
                rel="noreferrer noopener"
              >
                Changelog
              </a>
            </div>
          </div>
          <div className={styles.right}>
            <ProjectList />
            <div className={styles.footer}>
              <Button className={styles.button} onClick={this.handleOpen}>
                Select Schema
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
